// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6ae648a1","513":"6d3889d1","703":"d2bf5484"}[chunkId] + ".chunk.js";
};